import { render, staticRenderFns } from "./InfoRequestFundsPopup.vue?vue&type=template&id=b457e720"
import script from "./InfoRequestFundsPopup.vue?vue&type=script&lang=js"
export * from "./InfoRequestFundsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports